import type { BusinessHours } from "../types/storefront";

export function getStoreStatus(hours: BusinessHours[], now = new Date()) {
  if (!hours.length) return { isOpen: true, label: "Open for orders" };
  const schedule = hours.find((item) => item.day === now.getDay());
  if (!schedule || schedule.closed) return { isOpen: false, label: "Closed today" };
  const [openHour, openMinute] = schedule.open.split(":").map(Number);
  const [closeHour, closeMinute] = schedule.close.split(":").map(Number);
  const current = now.getHours() * 60 + now.getMinutes();
  const opens = openHour * 60 + openMinute;
  const closes = closeHour * 60 + closeMinute;
  if (current < opens) return { isOpen: false, label: `Opens at ${formatTime(schedule.open)}` };
  if (current >= closes) return { isOpen: false, label: "Closed" };
  if (closes - current <= 60) return { isOpen: true, label: `Closing soon, ${formatTime(schedule.close)}` };
  return { isOpen: true, label: "Open now" };
}

const formatTime = (time: string) => {
  const [hour, minute] = time.split(":").map(Number);
  return new Intl.DateTimeFormat("en-PK", {
    hour: "numeric",
    minute: "2-digit"
  }).format(new Date(2000, 0, 1, hour, minute));
};
